import Feature from '../node_modules/ol/Feature';
import LineString from '../node_modules/ol/geom/LineString';

 // 2023-12-30 switched from substr() to substringing()

function trav(params) {
  if (!params.startPoint) return
  let propmtTxt = 'Enter bearing ' + (params.bearingTxt || '')
  let input = prompt(propmtTxt, params.bearingInput)
  if (input) {
    input = input.trim()
    params.bearingInput = input
    let quadrant = input.substring(0,1)
    let angleArray = input.substring(1).split('.')
    let degrees = parseInt(angleArray[0])
    let minutes = parseInt(angleArray[1]?.substring(0,2) || 0)
    let seconds = parseFloat(angleArray[1]?.substring(2) || 0)
    // let angle = (degrees + (minutes + seconds / 60) / 60) * (Math.PI/180)
    let angle = (degrees + ((minutes) + (seconds / 60) ) /60) * (Math.PI/180)
    degrees = degrees.toString().padStart(2, '0')
    minutes = minutes.toString().padStart(2, '0')
    seconds = seconds.toString().padStart(2, '0')
    switch (quadrant) {
      case '1':
        angle = Math.PI / 2 - angle
        params.bearingTxt = `N${degrees}°${minutes}'${seconds}"E`
        break;
      case '2':
        angle = Math.PI * 1.5 + angle
        params.bearingTxt = `S${degrees}°${minutes}'${seconds}"E`
        break;
      case '3':
        angle = Math.PI * 1.5 - angle
        params.bearingTxt = `S${degrees}°${minutes}'${seconds}"W`
        break;
      case '4':
        angle = Math.PI / 2 + angle
        params.bearingTxt = `N${degrees}°${minutes}'${seconds}"W`
        break;
      default:
        alert('Error, quadrant must be between 1 an 4')
        return
    }
    params.angle = angle
    propmtTxt = params.bearingTxt + ' Enter distance:'
    input = prompt(propmtTxt, params.dist)
    if (input) {
      params.dist = parseFloat(input)
      const startPointSP = rwg.proj.transform(rwg.proj.mapSRID, rwg.proj.spSRID, params.startPoint)
      const endPointSP = [
        startPointSP[0] + params.dist * Math.cos(angle),
        startPointSP[1] + params.dist * Math.sin(angle)
      ]
      const endPoint = rwg.proj.transform(rwg.proj.spSRID, rwg.proj.mapSRID, endPointSP)
      if (!params.linestring) {
        params.linestring = new Feature( new LineString([params.startPoint, endPoint]) )
        params.source.addFeature(params.linestring)
      } else {
        params.linestring.getGeometry().appendCoordinate(endPoint)
      }

      params.startPoint = endPoint

      setTimeout(
        () => trav(params),
        100
      )
    } else {
      trav(params)
    }
  }
  return params.linestring
}
export {trav}
